// hooks/useSimFileValidation.ts
import { useCallback, useState } from "react";
import { validateSimsForAction } from "../redux/slices/sims";

export function useSimFileValidation() {
  const [validating, setValidating] = useState(false);
  const [report, setReport] = useState(null); // ImportValidationReport
  const [error, setError] = useState(null);

  const validateFile = useCallback(
    async ({ file, provider, simType, action = "import" }) => {
      setValidating(true);
      setError(null);
      try {
        const res = await validateSimsForAction({
          file,
          action,
          provider,
          simType,
        });
        setReport(res);
        return res;
      } catch (e) {
        setError(e.message);
        setReport(null);
        return null;
      } finally {
        setValidating(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setReport(null);
    setError(null);
    setValidating(false);
  }, []);

  return { validating, report, error, validateFile, reset };
}
